import { Button } from '@mui/material'
import { ErrorBoundary, SubmitSending } from 'components'

function Cta(_props) {
  const {
    children,
    isSubmitting = false,
    submittingLabel = 'Enviando',
    primary = null,
    color = 'primary',
    ...rest
  } = _props
  const buttonProps = Boolean(primary)
    ? { variant: 'contained' }
    : { variant: 'outlined' }
  return (
    <ErrorBoundary fallBack={ErrorFallback}>
      <Button
        {...buttonProps}
        color={color}
        {...rest}
        className="whitespace-nowrap"
      >
        {isSubmitting ? <SubmitSending label={submittingLabel} /> : children}
      </Button>
    </ErrorBoundary>
  )
}

const ErrorFallback = () => (
  <Button variant="outlined" disabled>
    Ocurrio un error con este botón
  </Button>
)

export default Cta
